import React from "react";
import { useParams } from "react-router-dom";
import cmsImage from "utils/cmsImage";
import detectLang from "utils/detectLang";
import _html from "utils/_html";
import imageUrl from "utils/imageUrl";
import { useTranslation } from "react-i18next";

const PitchCard = ({ setting }) => {
  // const { lang: _lang } = useParams();
  // const lang = _lang || 'en';
  const { t } = useTranslation();

  const lang = localStorage.getItem("i18nextLng") || "sp";
  return (
    <>
      {/* <div className="pitch-card-wrapper">
        <article className="pitch-card white">
          <div className="pitch-card-front">
            <img
              src={cmsImage(setting?.image)}
              onError={(e) =>
                (e.currentTarget.src = imageUrl("chart-image.png"))
              }
              alt=""
            />
          </div>
          <div className="pitch-card-back">
            {_html(detectLang(setting, "description", lang))}
          </div>
        </article>
      </div> */}
      <div className="p-c-wrapper">
        <div className="leftt">
          <img
            src='/images/progress-bar.png'
            onError={(e) =>
              (e.currentTarget.src = imageUrl("chart-image.png"))
            }
            alt=""
          />
        </div>
        <div className="rightt">
          {t("section_8.title") }
          {/* Minimum investment amount:The smallest amount of money that an investor can put into the business is 5000 Mexican PesosThe expected return on investment (ROI) for this business ranges from 10% to 38% per year or more. It's important to note that the actual ROI may be different than the expected ROI and can be affected by various factors. */}
        </div>
      </div>
    </>
  );
};

export default PitchCard;
